import { useCallback, useMemo } from 'react';
import { useQueryParams } from './use-query-params';

export const useLog = () => {
  const { debug } = useQueryParams();
  const showLog = useMemo(() => debug, [debug]);

  const log = useCallback(
    (...arg: any) => {
      if (showLog) {
        console.log(arg);
      }
    },
    [showLog]
  );

  const warn = useCallback(
    (...arg: any) => {
      if (showLog) {
        console.warn(arg);
      }
    },
    [showLog]
  );

  return { log, warn };
};
